import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { saloonImageOptions } from './views/saloon'

class X49MK2Saloon extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsSaloonChange = this.handleCupboardsSaloonChange.bind(this);
        this.handleTableBoxChange = this.handleTableBoxChange.bind(this);
        this.handlePouffesChange = this.handlePouffesChange.bind(this);
        this.handleBackrestChange = this.handleBackrestChange.bind(this);
    }


    handleCupboardsSaloonChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsSaloon = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTableBoxChange(event) {
        let configuration = this.props.configuration;
        configuration.TableBox = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handlePouffesChange(event) {
        let configuration = this.props.configuration;
        configuration.PouffeFabric = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };
        configuration.PouffeBase = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBackrestChange(event) {
        let configuration = this.props.configuration;
        configuration.Backrest = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloonImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='X49 Furniture Text' /></p>


                    <Toggle checked={this.props.configuration.CupboardsSaloon.value === 2} onChange={this.handleCupboardsSaloonChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.TableBox.value === 2} onChange={this.handleTableBoxChange}>
                        <Trans defaults='Table box' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.PouffeFabric.value === 2} onChange={this.handlePouffesChange}>
                        <Trans defaults='Pouffe' />
                    </Toggle>


                    <Toggle checked={this.props.configuration.Backrest.value === 2} onChange={this.handleBackrestChange}>
                        <Trans defaults='Back rest cushions' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2Saloon);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-Saloon.js